export function getQueryStr(params) {
  let queryStr = ''
  if (params) {
    let kvStr = []
    Object.entries(params).forEach((item) => {
      let [key, value] = item
      if (value !== undefined && value !== "") {
        kvStr.push(`${key}=${value}`)
      }
    });

    if(kvStr.length>0){
      queryStr = '?' + kvStr.join('&')
    }
  }
  return queryStr
}
export function getType(value) {
  let typ = Object.prototype.toString.call(value)
  return typ.replace('[object ', '').replace(']', '')
}
export function sizeStr(bytes) {
  if (bytes === 0) {return '0 B'}
  let k = 1024, // or 1000
    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
}
// 数组项目上移下移
export function listUp(list,index){
  let item = list[index]
  if (index > 0) {
    list.splice(index, 1)
    index -= 1
    list.splice(index, 0, item)
  }
  return index
}
export function listDown(list,index) {
  let item = list[index]
  if (index < list.length - 1) {
    list.splice(index, 1)
    index += 1
    list.splice(index, 0, item)
  }
  return index
}
export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj))
}

// 范围随机数
export function randomRange(min, max) {
  return parseInt(Math.random() * (max - min + 1) + min, 10);
}


/**解析 location.search */
export function parseSearchStr(search) {
  if (search === "") {
    return {}
  }
  let query = search.split("?")[1]
  query = query.split("&")
  let r = {}
  query.forEach(item => {
    let l = item.split("=")
    r[l[0]] = l[1]
  })
  return r
}

/*element**/
export function formValidate(formEl, ok, fail = () => {}) {
  formEl.validate((valid) => {
    try {
      if (valid) {
        ok()
      } else {
        fail()
      }
    } catch (e) {
      console.error(e)
    }
  })
}

export function toFixed2(num) {
  return Math.round(num * 100) / 100
}

export function getTimeStr(dateObj) {
  if (dateObj) {
    return dateObj.toLocaleString('chinese', {hour12: false}).replaceAll('/', '-')
  }
}



export function getTimestampS() {
  return parseInt(new Date().getTime() / 1000)
}

export function getTimestamp() {
  return new Date().getTime()
}


export function openFile(ok, accept = "*", multiple = true) {
  let input = document.createElement('input')
  input.setAttribute('type', 'file')
  input.setAttribute('accept', accept)
  input.setAttribute('multiple', multiple)
  input.addEventListener('change', e => {
    ok(e.target.files)
  })
  input.click()
}

export function getFileSuffix(filename) {
  filename = filename.split(".")
  if (filename.length > 1) {
    return filename[filename.length - 1]
  } else {
    return ""
  }
}

let isFullscreenState = false
export function toggleFullscreen() {
  if (!isFullscreenState) {
    let {documentElement} = document
    let requestFullscreen =
      documentElement.requestFullscreen ||
      documentElement.mozRequestFullScreen ||
      documentElement.webkitRequestFullScreen ||
      documentElement.msRequestFullscreen

    requestFullscreen.apply(documentElement)
    isFullscreenState = true
  } else {
    let exitFullscreen =
      document.exitFullscreen ||
      document.mozCancelFullScreen ||
      document.webkitCancelFullScreen ||
      document.msExitFullscreen

    exitFullscreen.apply(document)
    isFullscreenState = false
  }
  return isFullscreenState
}

// 判断是否是全屏
// 按F11时也能判断到，但按F11全屏后不能调用document.exitFullscreen退出全屏
// 既然用户会用F11，那也没必要考虑吧这种情况了吧
window.addEventListener('resize', () => {
  if(window.innerHeight >=
    screen.height - Math.abs(window.innerHeight - window.outerHeight)){
    // ..
  }

})


// 时间相关

export function dateToStr(datetime){
  datetime.setDate(datetime.getDate());
  let year = datetime.getFullYear();
  let month = datetime.getMonth()+1;//js从0开始取
  let date = datetime.getDate();
  let hour = datetime.getHours();
  let m = datetime.getMinutes();
  let s = datetime.getSeconds()
  month = month < 10 ?  "0" + month : month ;
  date  = date<10 ?  "0" + date : date;
  hour  = hour <10 ? "0" + hour : hour;
  s  = s <10 ? "0" + s : s;
  return year + "-" + month + "-" + date + ' ' + hour + ':' + m + ':' + s ;
}

export function dateTimeAdd(startTime,addValue,unit){
  let t = new Date(startTime)
  if(unit === '年'){t.setFullYear(t.getFullYear()+addValue)}
  else if(unit === '月'){t.setMonth(t.getMonth()+addValue)}
  else if(unit === '日'){t.setDate(t.getDate()+addValue)}
  else if(unit === '小时'){t.setHours(t.getHours()+addValue)}
  else if(unit === '分钟'){t.setMinutes(t.getMinutes()+addValue)}
  else {throw "单位错误"}
  return t.toLocaleString().replaceAll('/','-')
}


export function listToDict(list,keyName){
  let dict = {}
  list.forEach(item=>{
    dict[item[keyName]] = item
  })
  return dict
}




export function elFormVerifyAsync(formCom){
  return new Promise(resolve => {
    formCom.validate((valid, fields) => {
      if (!valid) {resolve(false)}
      else {resolve(true)}
    })
  })
}

/**
 * obj变化,禁止支持单层对象,并且值为基础类型
 * */
export function objEqual(obj1,obj2) {
  let obj1Keys = Object.keys(obj1)
  if (obj1Keys.length !== Object.keys(obj2).length) {
    return false
  }
  return obj1Keys.every(key => obj1[key] === obj2[key])


}

// 新数据的属性在老数据中都没有变化
// 所有数据都是基本类型
// 在新数据中字段减少也不做判断
export function ObjDataNotChange(oldData,newData){
  return Object.keys(newData).every(key=>newData[key]=oldData[key])
}
export function objToFormData(obj) {
 const formData = new FormData()
  Object.keys(obj).forEach(key =>{
    if(obj[key] instanceof Array) {
      obj[key].forEach(item => {
        formData.append(key, item);
      })
      return
    }
    formData.append(key,obj[key])
  })
  return formData
}

// =====list 工具
export function getDictFromList(list,keyName='v',valueKey='t'){
  let dict = {}
  list.forEach(item=>{
    dict[item[keyName]] =
      valueKey ? item[valueKey] : item
  })
  return dict
}
export function toDict(list,keyFilter,valueFilter){
  let dict = {}
  list.forEach(item=>{
    dict[keyFilter(item)] = valueFilter(item)
  })
  return dict
}
export function groupBy(list,key,valueFilter= item=>item){
  let dict = {}
  list.forEach(item=>{
    let indexKey = item[key]
    let list = dict[indexKey]
    if(list===undefined){
      list = []
      dict[indexKey] = list
    }
    list.push(valueFilter(item))
  })
  return dict
}

// ====dict 工具
export function dictMap(dict,filter){
  let newDict = {}
  Object.entries(dict).forEach(entry=>{
    let [key,value] = entry
    newDict[key] = filter(value)
  })
  return newDict
}

// ====tree 工具
export function treeGet(dict,...args){
  let len = args.length
  let cur = dict
  for(let i=0;i<len;i++){
    cur = cur[args[i]]
    if(cur===undefined){
      return cur
    }
  }
  return cur
}


//判断是否是图片
export function isAssetTypeAnImage(filePath) {
  //获取最后一个.的位置
  let index= filePath.lastIndexOf(".");
  //获取后缀
  let ext = filePath.substr(index+1)
  return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1
}
